import { select, call, put, takeLatest } from 'redux-saga/effects'
import { defineTypes } from '../../helpers'
import ReservationEndpoint from '../../persistence/ReservationEndpoint'
import { reduxFetch } from '../../http/reduxFetch'
import moment from 'moment'

const reservationSearch = { ...defineTypes('RESERVATION_SEARCH')  }

export const initialState = {
  loading: false,
  loaded: false,
  orders: [],
  query: undefined,
  search: undefined,
}

export const actions = {
  searchReservations (event) {
    return { type: reservationSearch.REQUEST, query: event }
  },
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case reservationSearch.REQUEST:
      return { ...state, query: action.query, started: true, loading: true }
    case reservationSearch.FAILURE:
      return { ...state, loading: false, error: action.error }
    case reservationSearch.SUCCESS:
      return { ...state, loading: false, orders: action.orders, loaded: true, created: true }
    default:
      return state
  }
}
export const selectors = {
  orders: (store) => {
    return store.reservation_search.orders
  },
  search: (store) => {
    return store.form && store.form.reservation_search && store.form.reservation_search.values.query
  },
  loaded: (store) => {
    return store.reservation_search.loaded
  },
  orderOptions: (store) => {
    let orderOptions = []
    let orders = store.reservation_search.orders || []
    orders.forEach(
      order =>
        orderOptions.push(
          {
            value: order.id,
            label: order && order.attributes && `${order.attributes.fullName} ${moment(order.attributes.createdAt).format('MM/DD/YYYY')}`
          }
        )
    )
    return orderOptions
  }
}

export function * searchReservationsSaga (action) {
  try {
    let response = yield call(reduxFetch, ReservationEndpoint.search(action.query))

    yield put({ type: reservationSearch.SUCCESS, orders: response.data })
  } catch (error) {
    yield put({ type: reservationSearch.FAILURE, error })
  }
}
export function * rootSaga () {
  yield takeLatest(reservationSearch.REQUEST, searchReservationsSaga)
}




// WEBPACK FOOTER //
// ./src/sagas/reservation/search.js